// extracted by mini-css-extract-plugin
var _1 = "OldMobileBanner_appContainer__SUTXQ";
var _2 = "OldMobileBanner_container__daZ+O";
var _3 = "OldMobileBanner_dbClose__mvc3X";
var _4 = "OldMobileBanner_dbCloseIcon__wiAd+";
var _5 = "OldMobileBanner_description__4M0Dq";
var _6 = "OldMobileBanner_details__9-Xgh";
var _7 = "OldMobileBanner_logoImage__6Sp03";
var _8 = "OldMobileBanner_openButton__lv2v4";
var _9 = "OldMobileBanner_title__AFfOv";
export { _1 as "appContainer", _2 as "container", _3 as "dbClose", _4 as "dbCloseIcon", _5 as "description", _6 as "details", _7 as "logoImage", _8 as "openButton", _9 as "title" }
